import { getInterval } from "../../utils";
import getDefaultAdminValues from "./default-admin-values";

export default ({ hasAdminPrivileges }) => {
  const [startDate, endDate] = getInterval();
  return {
    startDate,
    endDate,
    visible: false,
    billable: false,
    localRecInfo: undefined,
    ...getDefaultAdminValues(hasAdminPrivileges),
  };
};
